import React from 'react';
import deleteIcon from 'assets/icons/delete.svg';
import { Button, Col, Image, Modal, ModalProps, Row, Typography } from 'components';
import './styles.scss';

interface DeleteModalProps extends ModalProps {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

export const CommonDeleteModal: React.FC<DeleteModalProps> = (props) => {
  const {
    open,
    title,
    message = 'Are you sure you want to delete this item?',
    confirmText = 'Delete',
    cancelText = 'Cancel',
    isLoading = false,
    onClose,
    onOk,
    ...modalProps
  } = props;
  return (
    <Modal
      className={'delete-modal'}
      open={open}
      onCancel={onClose}
      closable={false}
      title={null}
      width={360}
      centered
      {...modalProps}
      footer={
        <Row gutter={[0, 20]}>
          <Col span={24}>
            <Row wrap={false} className="gap-8" style={{ margin: '24px 0 12px' }}>
              <>
                <Button block size="large" onClick={onClose}>
                  {cancelText}
                </Button>
                <Button loading={isLoading} danger block size="large" type="primary" onClick={onOk}>
                  {confirmText}
                </Button>
              </>
            </Row>
          </Col>
        </Row>
      }
    >
      <Row justify="center" gutter={[0, 24]}>
        <Col span={24}>
          <Image preview={false} src={deleteIcon} />
        </Col>
        <Col span={24}>
          <Typography.Title level={3}>{title}</Typography.Title>
        </Col>
        <Col span={24} style={{ marginTop: -22 }}>
          <Typography.Text>{message}</Typography.Text>
        </Col>
      </Row>
    </Modal>
  );
};
